import api from './api';

export const loginUser = async (email: string, password: string) => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    console.log("response from login", response);

    // The backend returns an array where index 0 is the data and index 1 is the status
    if (Array.isArray(response.data)) {
      const responseData = response.data[0];
      const statusCode = response.data[1];
      
      // Check if login failed (status 401 or error message)
      if (statusCode === 401 || responseData.message === 'Invalid email or password') {
        throw new Error(responseData.message || 'Invalid email or password');
      }
      
      // Check if login was successful
      if (statusCode === 200 && responseData.message === 'Login successful') {
        // Extract token from the user object if it exists, or use a default
        const token = responseData.user?.token || responseData.token || 'default-token';
        return {
          token: token,
          user: responseData.user,
          message: responseData.message
        };
      }
    }
    
    throw new Error('Unexpected response format');
    
  } catch (err: any) {
    // Forward the API error message
    throw err.message || err.response?.data?.message || "Login failed";
  }
};

export const registerAdmin = async (data: {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  phone_number: string;
  responsibility: string;
  role: string;
  year_of_employment: string;
}) => {
  const response = await api.post("/auth/register", data);
  console.log("response from signup", response)
  return response.data;
};
